/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { formatNumber } from "../../utils/numberFormatter";
import totalPerqsIcon from "../../assets/images/CirclePercent.svg";
import shiftPerqsIcon from "../../assets/images/Timer2.svg";
import homePerqsIcon from "../../assets/images/Home.svg";
import affiliatePerqsIcon from "../../assets/images/Handshake.svg";
import { useTranslation } from "react-i18next";
import { KpiCardGrid } from "../kpi_card_grid";

const GRID_COLUMNS = {
  xs: 2,
  sm: 2,
  md: 2,
  lg: 4,
};

const BORDER_COLOR = "#eee";

const ANALYTICS_CONFIG = [
  {
    key: "total_perqs",
    titleKey: "Total Perqs",
    descriptionKey: "Includes the total discount value from all employee perq redemptions across shift, home, and affiliate orders.",
    icon: totalPerqsIcon,
    iconAlt: "Total Perqs",
  },
  {
    key: "shift_perqs",
    titleKey: "Shift Perqs",
    descriptionKey: "Includes employee perq discounts redeemed on orders placed at the employee's shift hours.",
    icon: shiftPerqsIcon,
    iconAlt: "Shift Perqs",
  },
  {
    key: "home_perqs",
    titleKey: "Home Perqs",
    descriptionKey: "Includes employee perq discounts redeemed on orders placed at the employee's assigned home restaurant.",
    icon: homePerqsIcon,
    iconAlt: "Home Perqs",
  },
  {
    key: "affiliate_perqs",
    titleKey: "Affiliate Perqs",
    descriptionKey: "Includes employee perq discounts redeemed at affiliated restaurants outside the employee's home location.",
    icon: affiliatePerqsIcon,
    iconAlt: "Affiliate Perqs",
  },
];

const formatCurrency = (value) => `$${formatNumber(value)}`;

export const DiscountAnalyticsCards = ({ isMobile, data = {}, loading = false }) => {
  const { t } = useTranslation();

  const analyticsConfig = React.useMemo(
    () =>
      ANALYTICS_CONFIG.map((item) => ({
        ...item,
        title: t(item.titleKey),
        description: t(item.descriptionKey),
        icon: <img src={item.icon} alt={item.iconAlt} />,
        formatValue: formatCurrency,
        cardTestId: `discount-analytics-card-${item.key}`,
        titleTestId: `discount-analytics-title-${item.key}`,
        tooltipTestId: `discount-analytics-tooltip-${item.key}`,
        valueTestId: `discount-analytics-value-${item.key}`,
      })),
    [t]
  );

  return (
    <KpiCardGrid
      config={analyticsConfig}
      data={data}
      loading={loading}
      isMobile={isMobile}
      columns={GRID_COLUMNS}
      borderColor={BORDER_COLOR}
      containerTestId="discount-analytics-container"
      containerSx={{
        marginTop: "0px",
        marginBottom: "20px",
        border: `1px solid ${BORDER_COLOR}`,
        borderRadius: "10px",
      }}
    />
  );
};
